import {rawHttp} from '../../services/http';
import {CALL_CODE, PHONE_NUMBER, REGISTER_INTER_RISK_PATIENT, REGISTER_SIMPLY, SMS_CODE} from './accountApiEndpoints';
import {RegisterSimplyDto} from '../../types/register';
import {AuthResultDto} from '../../types/auth';
import { InsurancePackagePatientDto } from '../../types/insurancePackage';

class AccountApi {
    registerSimply(data: RegisterSimplyDto) {
        return rawHttp.put<AuthResultDto>(REGISTER_SIMPLY, data);
    }

    getUserPhoneNumber() {
        return rawHttp.get<{phoneNumber: string}>(PHONE_NUMBER);
    }

    verifyPhoneNumber(code: string) {
        return rawHttp.post<AuthResultDto>(SMS_CODE, {code});
    }

    callWithSmsCode()
    {
        return rawHttp.get(CALL_CODE);
    }

    registerInterRiskPatient(data: InsurancePackagePatientDto)
    {
        return rawHttp.post(REGISTER_INTER_RISK_PATIENT, data);
    }
}

export const accountApi = new AccountApi();
